import { makeActionCreator } from "../common/utils";
import {
  GET_ALL_KINDS,
  GET_ALL_KINDS_SUCCESS,
  GET_ALL_KINDS_FAILURE,
  SET_CURRENT_DASHBOARD_VIEW
} from "./actions";

export const getAllKinds = makeActionCreator(GET_ALL_KINDS);
export const getAllKindsSuccess = makeActionCreator(GET_ALL_KINDS_SUCCESS);
export const getAllKindsFailure = makeActionCreator(GET_ALL_KINDS_FAILURE);
export const setCurrentDashboardView = makeActionCreator(
  SET_CURRENT_DASHBOARD_VIEW
);
